import { createSelector } from 'reselect';
import { BUILDING_BLOCKS } from '../../constants/buildingBlocks';
import { getIsEditingGridLayouts } from './moduleSelectors';
import { getIsUngatedForPegboards } from './authSelectors';
export const getCategoryToBuildingBlocksMap = createSelector([getIsEditingGridLayouts, getIsUngatedForPegboards], (isEditingGridLayouts, isUngatedForPegboards) => {
  return isEditingGridLayouts ? {
    CONTAINERS: BUILDING_BLOCKS(isUngatedForPegboards)
  } : {
    CONTAINERS: []
  };
});